import React, { Suspense } from 'react';
import { useTypedSelector } from '@hooks';
import { useAuth } from '@hooks/useAuth';
import { useDebounced } from '@helpers/useDebounced';

const DuplicateProjectModal = React.lazy(
  () => import('./DuplicateProjectModal')
);

export default function DuplicateProjectModalContainer() {
  const { user } = useAuth();
  const modalState = useTypedSelector(
    ({ modal }) => modal.duplicateProjectModal
  );
  const visibleDebounced = useDebounced(modalState?.visible, 300, false);
  const visible = modalState?.visible || visibleDebounced;
  if (!modalState || !visible || !user) return null;

  return (
    <Suspense fallback={null}>
      <DuplicateProjectModal {...modalState} key={modalState.campaignId} />
    </Suspense>
  );
}
